import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '@app/tw-shared/components';
import { DropdownOpenCloseService } from '@app/tw-shared/directives/dropdown-open-close/dropdown-open-close.service';
import { ListItemDirective } from '@app/tw-shared/directives/list-item/list-item.directive';
import { ListDirective } from '@app/tw-shared/directives/list/list.directive';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkActiveTriggerDirective } from '../../directives';
import { NavItemAdminService } from '../../services';
import { AdminSettingsNavItemsService } from '../../services/admin-settings-nav-items.service';

@Component({
    selector: 'app-nav-item-admin-list',
    imports: [CommonModule, RouterModule, TranslateModule, IconComponent, ListDirective, ListItemDirective, RouterLinkActiveTriggerDirective],
    templateUrl: './nav-item-admin-list.component.html',
    styleUrl: './nav-item-admin-list.component.scss'
})
export class NavItemAdminListComponent {
    @Input() open = false;
    private readonly navItemAdminService = inject(NavItemAdminService);
    private readonly dropdownOpenCloseService = inject(DropdownOpenCloseService);
    private readonly adminSettingsNavItemsService = inject(AdminSettingsNavItemsService);

    readonly listId = this.navItemAdminService.listId;

    readonly items$ = this.adminSettingsNavItemsService.items$;

    onRouteActive(active: boolean) {
        this.navItemAdminService.active$.next(active);
    }

    close() {
        this.dropdownOpenCloseService.openEvent$.next(false);
    }
}
